import Button from "../button";
import {
  Calendar,
  ChevronLeft,
  ChevronRight,
  CogIcon,
  Help,
  PresentationIcon,
  WorkfullyLogo,
} from "../../assets/icons";
import Tooltip from "../tooltips/Tooltips";
import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import UseContext from "../../hooks/useContext";

const ICON_COLOR = "#374151";

const navLinkClassName = ({ isActive }) =>
  [
    "w-full flex gap-4 items-center px-2 py-3 cursor-pointer rounded-lg border-0 no-underline transition-colors text-sm font-normal leading-normal",
    isActive
      ? "bg-gray-100 text-gray-700 hover:bg-gray-100"
      : "text-gray-700 hover:bg-gray-50",
  ].join(" ");

const externalLinkClassName =
  "w-full flex gap-4 items-center px-2 py-3 cursor-pointer rounded-lg border-0 text-gray-700 hover:bg-gray-50 transition-colors text-sm font-normal leading-normal";

const SidebarSite = () => {
  const { userData } = UseContext();
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [sidebarElements] = useState([
    {
      title: "Suivi horaire",
      icon: <Calendar wh={20} color={ICON_COLOR} />,
      path: "/hourly-tracking",
      type: "content",
      allowRoles: [225, 215, 210, 205, 200],
    },
    {
      title: "Activité",
      icon: <PresentationIcon wh={20} color={ICON_COLOR} />,
      path: "/activity",
      type: "content",
      allowRoles: [225, 215, 210],
    },
    {
      title: "Paramètres",
      icon: <CogIcon wh={20} color={ICON_COLOR} />,
      path: "/settings/team",
      type: "content",
      allowRoles: [225],
      matchSettingsSection: true,
    },
    {
      title: "Aide",
      icon: <Help wh={20} color={ICON_COLOR} />,
      path:
        "https://docs.google.com/document/d/1YQsrqNKgSR3q64lyCGCCkR-oVvC8d9tN4vZCrCOSUxk/edit?usp=sharing",
      pathOptions: { target: "_blank", rel: "noopener noreferrer" },
      type: "content",
      allowRoles: [225, 215, 210, 205, 200],
    },
  ]);

  const location = useLocation();

  const renderInternalNavLink = (element, key) => (
    <NavLink
      key={key}
      to={element.path}
      className={({ isActive }) =>
        navLinkClassName({
          isActive:
            element.matchSettingsSection === true
              ? isActive ||
                location.pathname.startsWith("/settings") ||
                location.pathname.startsWith("/organization/settings")
              : isActive,
        })
      }
    >
      <div>{element.icon}</div>
      {sidebarExpanded && <div>{element.title}</div>}
    </NavLink>
  );

  const renderContentItem = (element, key) => {
    if (element.path.startsWith("http")) {
      return (
        <a
          href={element.path}
          key={key}
          target={element.pathOptions?.target || "_self"}
          rel={element.pathOptions?.rel || ""}
          className={externalLinkClassName}
        >
          <div>{element.icon}</div>
          {sidebarExpanded && <div>{element.title}</div>}
        </a>
      );
    }
    return renderInternalNavLink(element, key);
  };

  return (
    <div
      className={`px-5 py-8 flex flex-col h-full ${
        sidebarExpanded ? "w-64 transition-w-64" : "w-20 transition-w-20"
      } duration-700 gap-11 border-r border-r-gray-100 bg-white`}
    >
      <div className={"flex justify-between gap-8 items-center"}>
        {sidebarExpanded && (
          <div>
            <WorkfullyLogo w={130} h={30} />
          </div>
        )}
        <Tooltip
          text={sidebarExpanded ? "Reduire" : "Agrandir"}
          placement="right"
        >
          <div>
            <Button
              color={"ICON"}
              size={"ICON"}
              onClick={() => setSidebarExpanded(!sidebarExpanded)}
            >
              {sidebarExpanded ? (
                <ChevronLeft wh={20} color={"#374151"} />
              ) : (
                <ChevronRight wh={20} color={"#374151"} />
              )}
            </Button>
          </div>
        </Tooltip>
      </div>
      <div className={"flex-1 py-4 text-sm"}>
        {sidebarElements
          .filter(
            (element) =>
              element.type === "content" &&
              element.allowRoles.includes(userData?.role || 215),
          )
          .map((element, key) => renderContentItem(element, key))}
      </div>
    </div>
  );
};

export default SidebarSite;
